module.exports = __webpack_public_path__ + "static/HGK-5abdf16e790f05d406aae470badce8f0.png";